import { DataGrid } from '@mui/x-data-grid';
import { Box, Paper, Typography } from '@mui/material';
import { OtherStatisticProps } from '../../../helpers/types';
import { useStrategyQuery } from 'hooks/useStrategyQuery';
import { useStatisticGrid } from '../../../hooks/useStatisticGrid';

const OtherStatistic = ({ dateRange, columnPeriods }: OtherStatisticProps) => {
  const { data: stockData } = useStrategyQuery();
  const { gridColumns, buildRow, gridStyles } = useStatisticGrid({
    columnPeriods,
    stockName: stockData?.name
  });

  const rows = [
    buildRow('Upside Capture Ratio', ['1.23', '2.34', '3.45', '4.56'], 1),
    buildRow('Downside Capture Ratio', ['5.67', '6.78', '7.89', '8.90'], 2),
    buildRow('Standard Deviation', ['5.67', '6.78', '7.89', '8.90'], 3),
    buildRow(`${stockData?.name} Stock`, [], 4),
    buildRow('Standard Deviation', ['5.67', '6.78', '7.89', '8.90'], 5),
  ];

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
        Other Statistic
      </Typography>
      <Paper elevation={1}>
        <DataGrid
          autoHeight
          rows={rows}
          columns={gridColumns}
          hideFooter
          disableColumnMenu
          disableRowSelectionOnClick
          disableColumnFilter
          sx={gridStyles}
        />
      </Paper>
    </Box>
  );
};

export default OtherStatistic;
